import React from "react";
import PropTypes, { arrayOf } from "prop-types";
import Checkbox from "../../../elements/checkbox";
import { generateReactKey } from "../../../utils/reactKey";

const CheckboxTool = ({ options = [] }) => (
  <div className="checkbox-tool">
    {options.map(({ infoText, ...option }) => (
      <Checkbox
        key={generateReactKey()}
        infoText={`<p>${infoText}</p>`}
        {...option}
      />
    ))}
  </div>
);

CheckboxTool.propTypes = {
  options: arrayOf(
    PropTypes.shape({
      infoText: PropTypes.string
    })
  )
};

export default CheckboxTool;
